<template>
  <div class="container">
    <b-row>
      <ccv-simple-bar-chart
        :data="return_data"
        :options="return_options"
      ></ccv-simple-bar-chart>
    </b-row>
    <div class="mt-5">
      <b-tabs content-class="mt-3">
        <b-tab title="OVERALL STATS" active>
          <OverviewChart :data="stock_option_array" :total_fund="total_fund" />
        </b-tab>
        <b-tab title="WINNING STATS">
          <WinningChart :data="stock_option_array" :total_fund="total_fund" />
        </b-tab>
        <b-tab title="LOSING STATS">
          <LossingChart :data="stock_option_array" :total_fund="total_fund" />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import defaultImage from "../assets/images/default.png";
import db from "../../database/index";
const journal_collection = db.collection("journal_data");
const fund_collection = db.collection("fund_data");
import OverviewChart from "@/components/OverviewCharts";
import LossingChart from "@/components/LossingChart";
import WinningChart from "@/components/WinningChart";
// import * as dfd from "danfojs/src";

export default {
  name: "Overview",
  props: {
    discord_id: {
      type: String,
    },
  },
  components: {
    OverviewChart,
    LossingChart,
    WinningChart,
  },
  data() {
    return {
      defaultImage,
      stock_option_array: [],
      fund_data:[],
      total_fund:0,
      id: this.$route.params.id,
      df: null,
      return_data: [],
      return_options: {
        title: "Accumulative Returns",
        axes: {
          left: {
            mapsTo: "value",
          },
          bottom: {
            mapsTo: "group",
            scaleType: "labels",
          },
        },
        toolbar: {
          enabled: false,
        },
        height: "400px",
      },
    };
  },
  async mounted() {
    this.load_data();
    // const s = new dfd.Series([1,2,3,4,5])
    // s.print();
  },
  methods: {
    load_data() {
      journal_collection
        .doc(this.id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.stock_option_array = Object.values(doc.data());
            this.calAccReturnData();
          } else {
            this.isBusy = false;
          }
        })
        .catch((err) => console.log(err));

      fund_collection
        .doc(this.id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.fund_data = Object.values(doc.data());
          }
        })
        .then(() => {
          this.total_fund = this.fund_data.reduce(function (accumulator, item) {
            if (item.type === "Deposit") {
              return accumulator + item.amount;
            } else {
              return accumulator - item.amount;
            }
          }, 0);
        })
        .catch((err) => console.log(err));
    },
    async calAccReturnData() {
      let data = {};
      this.stock_option_array.forEach((ele) => {
        let date = new Date(ele["date"]).toLocaleDateString();
        if (date in data) {
          data[date] += Math.ceil(ele["returned_amount"]);
        } else {
          data[date] = Math.ceil(ele["returned_amount"]);
        }
      });
      this.return_data = Object.entries(data).map(([group, value]) => ({
        group,
        value,
      }));
      console.log(this.return_data);
    },
  },
};
</script>

<style scoped>
.container {
  color: #f8f8f8;
}
</style>